import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { PaymentSettings } from '../models/PaymentMoldes';

@Injectable({
  providedIn: 'root'
})
export class PaymentService {

  refreshList = new BehaviorSubject<boolean>(false);
  refreshDetails = new BehaviorSubject<boolean>(false);

  constructor(private http: HttpClient) { }

  GetPaymentSettings(restaurantId: number): any {
    return this.http.get(`${environment.apiUrl}/ResRestaurant/ResGetPaymentMethodsSettings?RestaurantId=${restaurantId}`);
  }
  SavePaymentSettings(data: PaymentSettings) {
    return this.http.post(`${environment.apiUrl}/ResRestaurant/ResSavePaymentMethodsSettings`, data);
  }
  /*****************************
   * NFC Configuration
   */
  ResGetRestaurantNearpayNFCSetting(restaurantId: number) {
    return this.http.get(`${environment.apiUrl}/ResRestaurant/ResGetRestaurantNearpayNFCSetting?restaurantId=${restaurantId}`);
  }
  ResSetRestaurantNearpayNFCSetting(data: any) {
    return this.http.post(`${environment.apiUrl}/ResRestaurant/ResSetRestaurantNearpayNFCSetting`, data);
  }
  ResGetRestaurantNFCUsersList(restaurantId: number) {
    return this.http.get(`${environment.apiUrl}/ResRestaurant/ResGetRestaurantNFCUsersList?restaurantId=${restaurantId}`);
  }
  /*****************************
   * NEOLEAP Configuration
   */
  GetRestaurantNeoLeapConfiguration(restaurantId: number) {
    return this.http.get(`${environment.apiUrl}/NeoLeap/GetRestaurantNeoLeapConfiguration?restaurantId=${restaurantId}`);
  }
  SetRestaurantNeoLeapConfiguration(data: any) {
    return this.http.post(`${environment.apiUrl}/NeoLeap/SetRestaurantNeoLeapConfiguration`, data);
  }
  GetResNeoLeapUsersList(restaurantId: number) {
    return this.http.get(`${environment.apiUrl}/NeoLeap/GetResNeoLeapUsersList?restaurantId=${restaurantId}`);
  }
  GetTerminalList(data: any) {
    return this.http.post(`${environment.apiUrl}/NeoLeap/GetTerminalList`, data);
  }
  EnableAndDisableTerminal(data: any) {
    return this.http.post(`${environment.apiUrl}/NeoLeap/EnableAndDisableTerminal`, data);
  }
  DeleteTerminal(terminalId: number) {
    return this.http.delete(`${environment.apiUrl}/NeoLeap/DeleteTerminal?terminalId=${terminalId}`);
  }
  UpdateTerminal(data: any) {
    return this.http.post(`${environment.apiUrl}/NeoLeap/UpdateTerminal`, data);

  }
  /*
   * Paymob Configuration
   */
  ValidateAPIKey(data: any) {
    return this.http.post(`${environment.apiUrl}/Paymob/ValidateAPIKey`, data);
  }
  SetRestaurantPaymobConfiguration(data: any) {
    return this.http.post(`${environment.apiUrl}/Paymob/SetRestaurantPaymobConfiguration`, data);
  }
  GetRestaurantPaymobConfiguration(restaurantId: any) {
    return this.http.get(`${environment.apiUrl}/Paymob/GetRestaurantPaymobConfiguration?restaurantId=${restaurantId}`);
  }
}
